module.exports = __webpack_public_path__ + "a37d6b3203355365d31ac386af8f2fc4.MP3";